import { combineEpics } from "redux-observable";
import "./views/ComputeList/epics/index.js";
import "./views/ComputeDetail/epics/index.js";
import "./views/ComputeCreate/epics/index.js";
import { getComputeEpicReducer } from "./ducks/GetCompute.ducks.js";
import { getComputeListEpicReducer } from "./ducks/GetComputeList.ducks.js";
import { deleteComputeEpicReducer } from "./ducks/DeleteCompute.ducks.js";
import { putComputeEpicReducer } from "./ducks/PutCompute.ducks.js";
import { rootEpic as rootEpic$1 } from "./views/ComputeList/epics/epics.js";
import { rootEpic as rootEpic$2 } from "./views/ComputeDetail/epics/epics.js";
import { rootEpic as rootEpic$3 } from "./views/ComputeCreate/epics/epics.js";
const rootEpic = combineEpics(
  rootEpic$1,
  rootEpic$2,
  rootEpic$3,
  getComputeEpicReducer.epic,
  getComputeListEpicReducer.epic,
  deleteComputeEpicReducer.epic,
  putComputeEpicReducer.epic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
